export default __webpack_public_path__ + "static/media/screenshot.abc41430.png";